import { render, staticRenderFns } from "./form-taxrate.vue?vue&type=template&id=051318f4&"
import script from "./form-taxrate.vue?vue&type=script&lang=js&"
export * from "./form-taxrate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports